import { render, staticRenderFns } from "./OneItem.vue?vue&type=template&id=36433c95&scoped=true&"
import script from "./OneItem.vue?vue&type=script&lang=js&"
export * from "./OneItem.vue?vue&type=script&lang=js&"
import style0 from "./OneItem.vue?vue&type=style&index=0&id=36433c95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36433c95",
  null
  
)

export default component.exports